import React from 'react';

import PropTypes from 'prop-types';

import {
  LinearProgress,
  Typography,
  Box,
} from '@mui/material';

const LinearProgressWithLabel = ({
  value,
  label,
  showPercentage = true,
}) => {

  return (

    <Box sx={{ width: '100%' }}>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mb: 1,
        }}
      >

        <Typography
          variant="body2"
          sx={{
            color: '#475569',
            fontWeight: 500,
          }}
        >
          {label || 'Loading...'}
        </Typography>

        {
          showPercentage && (

            <Typography
              variant="body2"
              sx={{
                color: '#0f172a',
                fontWeight: 600,
              }}
            >
              {Math.round(value)}%
            </Typography>

          )
        }

      </Box>

      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          height: 10,
          borderRadius: 10,
          backgroundColor: '#e2e8f0',

          '& .MuiLinearProgress-bar': {
            borderRadius: 10,
            background:
              'linear-gradient(90deg,#212668,#212668)',
            transition:
              'transform 0.2s linear',
          },
        }}
      />

    </Box>

  );
};

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string,
  showPercentage: PropTypes.bool,
};

export default LinearProgressWithLabel;